enum Fonts {
  nunito = 'Nunito, sans-serif',
  ptSans = 'PT Sans, sans-serif',
  roboto = 'Roboto, sans-serif',
  mono = '"IBM Plex Mono", monospace', // Actual "Roboto Mono" have some glyphs with different width
}

export default Fonts;
